import {
    DATIQ_DEFAULT_ARRAY,
    DATIQ_DEFAULT_EMPTY_LABEL,
    DATIQ_DEFAULT_ID,
    DATIQ_DEFAULT_BOOLEAN,
} from '@dat/datiq-core/models';
import {
    IDatiqGraphLegend,
    IDatiqGraphLegendLabel,
} from './datiq-graph-legend.interface';

export const getGraphLegendStyle = (
    color: string
): Partial<CSSStyleDeclaration> => {
    return {
        color,
    };
};

export const emptyDatiqGraphLegendLabel: IDatiqGraphLegendLabel = {
    id: DATIQ_DEFAULT_ID('datiq-graph-legend-label'),
    label: DATIQ_DEFAULT_EMPTY_LABEL,
    disabled: DATIQ_DEFAULT_BOOLEAN,
};

export const emptyDatiqGraphLegend: IDatiqGraphLegend = {
    labels: DATIQ_DEFAULT_ARRAY as IDatiqGraphLegendLabel[],
};
